import type { StepDef } from './runner';
import type { DecodedNewRow, DecodedUpdateRow } from './types';

/**
 * The engine playbook for a `new` row: one call that writes the site, its
 * geography and its activity in a single transaction. A failure leaves none
 * of them behind, so there is nothing to sequence and nothing to unwind.
 */
export const newRowSteps: StepDef<DecodedNewRow>[] = [
    {
        shouldRun: () => true,
        run: async (row, mutators) => {
            const { id } = await mutators.createCompleteSite({ site: row.site, geography: row.geography, activity: row.activity });
            return { siteId: id };
        },
    },
];

/**
 * The engine playbook for an `update` row: only the writes whose sub-object
 * is present on the decoded row fire. `decode()` upstream is responsible for
 * including each sub-object iff the corresponding fields appear in the
 * engine's `changes` list — pipelines here just consume that signal.
 */
export const updateRowSteps: StepDef<DecodedUpdateRow>[] = [
    {
        shouldRun: row => row.site !== undefined,
        run: async (row, mutators) => {
            await mutators.updateSite(row.internalId, row.site!);
            return {};
        },
    },
    {
        shouldRun: row => row.geography !== undefined,
        run: async (row, mutators) => {
            await mutators.createGeography(row.internalId, row.geography!);
            return {};
        },
    },
    {
        shouldRun: row => row.activity !== undefined,
        run: async (row, mutators) => {
            await mutators.setActivity(row.internalId, row.activity!);
            return {};
        },
    },
];
